module.exports = __webpack_public_path__ + "static/media/bag-game-entry-multi.4bcbce2c.png";